import { css } from "@emotion/react";
import { useTranslations } from "next-intl";

import { Icon } from "@zapier/zinnia-icons";
import { Button } from "@zapier/design-system";
import { FullStoryAPI } from "@zapier/react-fullstory";

import { SizeType } from "@zapier/reporting/src/hooks";
import { getResponsiveStyles } from "@zapier/reporting/src/utils";

type Props = {
  count: number;
  getCachedRuns: () => any[];
  isDisabled: boolean;
  onDelete: () => void;
  onDownload: () => void;
  onReplay: () => void;
  size: SizeType;
};

const rootStyle = getResponsiveStyles({
  desktop: css`
    align-items: center;
    justify-content: flex-start;
  `,
  tablet: css`
    grid-auto-flow: column;
  `,
  mobile: css`
    display: grid;
    grid-gap: 10px;
  `,
});

function RunActions(props: Props) {
  const t = useTranslations("run-log.run-actions");
  const selectedRuns = props.getCachedRuns();
  const hasNonSuccess = selectedRuns.find((run) => run.status !== "success");
  const playOrReplayText = t("play-or-replay", {
    hasNonSuccess: String(Boolean(hasNonSuccess)),
    count: props.count,
  });

  return (
    <div css={rootStyle}>
      <Button
        variant="primary"
        isDisabled={props.isDisabled}
        onPress={() => {
          props.onReplay();
          FullStoryAPI("event", "massRunReplay", {
            itemCount: selectedRuns.length.toString(),
          });
        }}
        iconPosition="start"
      >
        <Icon name="actionPlay" />
        {playOrReplayText}
      </Button>
      <Button
        variant="secondary"
        isDisabled={props.isDisabled}
        onPress={() => {
          props.onDelete();
          FullStoryAPI("event", "massRunDelete", {
            itemCount: selectedRuns.length.toString(),
          });
        }}
        iconPosition="start"
      >
        <Icon name="actionTrash" />
        {t("delete", { count: props.count })}
      </Button>
      <Button
        variant="tertiary"
        onPress={() => {
          props.onDownload();
          FullStoryAPI("event", "downloadRuns", {
            itemCount: selectedRuns.length.toString(),
          });
        }}
        iconPosition="start"
      >
        <Icon name="arrowBigDown" />
        {t("download", { count: props.count })}
      </Button>
    </div>
  );
}

export default RunActions;
